import { LanguageCode } from '@/shared/types';

import { languages } from './dictionary';
import { recordLanguageIcon } from './icons';
import { LanguageInfo } from './types';

type Item = {
  key: string;
  label: string;
};

let selectOptions: Item[];
export const getSelectLanguagesOptions = (): Item[] => {
  if (!selectOptions) {
    selectOptions = languages.map((item) => ({
      key: item.code,
      label: item.i18nEn,
    }));
  }

  return selectOptions;
};

const mapItems: [LanguageCode, LanguageInfo][] = languages.map((item) => [
  item.code,
  { ...item, icon: recordLanguageIcon[item.code]?.icon },
]);
export const languagesMap = new Map<LanguageCode, LanguageInfo>(mapItems);

export const getLanguageName = (code?: string) => {
  return languages.find((c) => c.code === code)?.i18nEn ?? code;
};
